import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inputValue',
})
export class InputValuePipe implements PipeTransform {
  transform(event: Event): string {
    return (event.target as HTMLInputElement).value;
  }
}
